module.exports = __webpack_public_path__ + "media/大国工匠2023年度人物——张帅坤.43e3142a.mp4";